export default __webpack_public_path__ + "static/media/nutrition3.c9a4fa75.gif";